import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import JsonSchema from '../SchemaOrgMeta/SchemaOrgMeta'


// set possible vars, there are quite a few
var {
  //drupal_internal__nid,
  //schema_data,
  schema_source_data,
  robots,
  canonical,
  //langcode,
  //title,
  //summary,
  description,
  keywords,
  image_src,
  siteUrl,
  //siteTitle,
  //siteLogo,
  //siteDescription,
  og_description,
  og_title,
  og_image,
  //og_site_name,
  og_url,
  twitter_cards_description,
  twitter_cards_site,
  twitter_cards_site_id,
  twitter_cards_title,
  //twitter_cards_type,
  twitter_cards_creator,
  twitter_cards_image,
  twitter_cards_page_url
  //,
  //schema_article_author,
  //schema_article_date_published,
  //schema_article_description,
  //schema_article_headline,
  //schema_article_name,
  //schema_article_review,
  //schema_article_type,
  //schema_person_contact_point,
  //schema_person_description,
  //schema_person_email,
  //schema_person_job_title,
  //schema_person_name,
  //schema_person_same_as,
  //schema_person_telephone,
  //schema_person_type,
  //schema_person_url,
  //schema_web_site_name,
  //schema_web_site_publisher,
  //schema_web_site_type,
  //schema_web_site_url
} = ''



// FUNCTION renderHead
// process page data and updates the <head> data on page change
// uses react Helmet
// - pagetitle (string): the page title
// - meta: the meta data object, typically page.field_meta_data
// - page: the page data object, typically page
const renderHead = function(title, meta, page, id) {
  // console.log("-- renderHead --")
  // console.log(title)
  // console.log(meta)
  if (meta) {
    if (meta.title) title = <title key="{index}">{meta.title}</title>
    //if (meta.robots) robots = <meta key="set-robots" name="robots" content={meta.robots} />
    if (meta.description) description = <meta key={meta.description} name="description" content={meta.description} />
    if (meta.keywords) keywords = <meta name="keywords" content={meta.keywords} />
    //if (meta.canonical_url) canonical = <link rel="canonical" href={meta.canonical_url} />
    if (meta.image_src) image_src = <link rel="image_src" href={meta.image_src} />

    // open graph
    if (meta.og_url) og_url = <meta property="og:url" content={meta.og_url} />
    if (meta.og_title) og_title = <meta property="og:title" content={meta.og_title} />
    if (meta.og_description) og_description = <meta property="og:description" content={meta.og_description} />
    if (meta.og_image) og_image = <meta property="og:image" content={meta.og_image} />

    // twitter
    if (meta.twitter_cards_description) twitter_cards_description = <meta name="twitter:description" content={meta.twitter_cards_description} />
    if (meta.twitter_cards_site) twitter_cards_site = <meta name="twitter:site" content={meta.twitter_cards_site} />
    if (meta.twitter_cards_title) twitter_cards_title = <meta name="twitter:title" content={meta.twitter_cards_title} />
    if (meta.twitter_cards_site_id) twitter_cards_site_id = <meta name="twitter:site:id" content={meta.twitter_cards_site_id} />
    if (meta.twitter_cards_creator) twitter_cards_creator = <meta name="twitter:creator" content={meta.twitter_cards_creator} />
    if (meta.twitter_cards_site_id) twitter_cards_site_id = <meta name="twitter:creator:id" content={meta.twitter_cards_site_id} />
    if (meta.twitter_cards_page_url) twitter_cards_page_url = <meta name="twitter:url" content={meta.twitter_cards_page_url} />
    if (meta.twitter_cards_image) twitter_cards_image = <meta name="twitter:image" content={meta.twitter_cards_image} />

  }

  // defaults - take data from node if no explicit meta data available
  if(!title) title = <title>{title}</title> // use default page title if no custom meta title
  if(page){
    //if (page.path && page.path.alias && !canonical) canonical = <link key={siteUrl + page.path.alias} rel="canonical" href={siteUrl + page.path.alias} />
    //if (page.path && page.path.langcode) langcode = page.path.langcode
    if(!title) title = <title>{page.title}</title> // use default page title if no custom meta title
    //if(!description && page.body.summary) description = <meta name="description" content={page.body.summary} /> // use default body summary if no custom meta description
  }

  // default robots - index and follow
  robots = <meta data-react-robot="default" key="default-robots" name="robots" content="index, follow" />

  return([
      title,
      description,
      keywords,
      robots,
      canonical,
      image_src,
      og_description,
      og_title,
      og_image,
      og_url,
      twitter_cards_description,
      twitter_cards_site,
      twitter_cards_site_id,
      twitter_cards_title,
      twitter_cards_creator,
      twitter_cards_site_id,
      twitter_cards_page_url,
      twitter_cards_image
  ])
}







// Initialise the site head with base values
// these get overwritten on page change
// renderHead() called by each page and passed the page's meta
const SEO = ({ drupal_id, title }) => {

  const {pagedata,site} = useStaticQuery(getDataHome)

  var page = pagedata.edges[0].node // to do

  if(site.siteMetadata){
    if (site.siteMetadata.siteUrl) siteUrl = site.siteMetadata.siteUrl
    //if (site.siteMetadata.title) siteTitle = site.siteMetadata.title
    //if (site.siteMetadata.image) siteLogo = site.siteMetadata.image
    //if (site.siteMetadata.description) siteDescription = site.siteMetadata.description
  }

  if(page.drupal_internal__nid) {
    //drupal_internal__nid = <div name="nid" >{page.drupal_internal__nid} </div>
  }

  // JsonLd schema
  schema_source_data = { ...page.field_meta_tags, ...site } // data passed to SchemaOrgMeta widget later on

  // OneTrust : set preprod / prod
  let otScriptProd = false; // default to prod
  if (typeof window === "undefined" || !window.document) {
    // SSR
  } else {
    const hostname = window.location.hostname;
    // NOTE: OneTrust prod scripts disabled
    // - Currently the OT prod scripts break the site
    // - A support ticket is being raised with OT
    // if(hostname.includes('jmfinn.com')) {
    //   otScriptProd = true;
    // }
  }
  const consentDefault = `
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  // Set default consent to 'denied' as a placeholder
  // Determine actual values based on your own requirements
  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied'
  });
  `;

  return (
    <>
      <Helmet>
        <html lang="en" />
        <script type="text/javascript">
           {consentDefault}
        </script>

        {/* {otScriptProd ? 
          <script type="text/javascript" src="https://cdn-ukwest.onetrust.com/consent/6d6a630f-e73a-4580-bc2f-1265d6cfd4c3/OtAutoBlock.js"></script>
        : 
          <script type="text/javascript" src="https://cdn-ukwest.onetrust.com/consent/6d6a630f-e73a-4580-bc2f-1265d6cfd4c3-test/OtAutoBlock.js"></script>
        }
        {otScriptProd ? 
          <script src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js" type="text/javascript" charset="UTF-8" data-domain-script="6d6a630f-e73a-4580-bc2f-1265d6cfd4c3"></script>
        : 
        <script src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js" type="text/javascript" charset="UTF-8" data-domain-script="6d6a630f-e73a-4580-bc2f-1265d6cfd4c3-test"></script>
        } */}

        {renderHead(title, page.field_meta_tags, page)}
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      </Helmet>
      {/* <script type="text/javascript">
           {'function OptanonWrapper() {}'}
      </script> */}
      <JsonSchema json={schema_source_data}/>
    </>
  )
}


export default SEO
export { renderHead }




// NOTES ~ WHEN ADDING TO THIS LIST
// - updates need to be made in gatsby-node.js
// - null fields naturally will be exculded by Gatsby causing the site to hard error
// - additions below need to be added to the createSchemaCustomization in gatsby-node.js
// - query targets the site homepage for the defaults

// TESTS:
//  page:nodePage(path: {alias: {eq: "/home" }}) {
//  page:nodePage(path: {alias: {eq: $path }}) {
//  pagedata:allNodePage(filter: {drupal_internal__nid: {eq: 6}}) {
const getDataHome = graphql`
query SEO {
  pagedata:allNodePage(filter: {path: {alias: {eq: "/homepage"}}}) {
    edges {
      node {
        drupal_internal__nid
        field_meta_tags {
          title
          description
          keywords
          image_src
          robots
          canonical_url
          og_title
          og_determiner
          og_description
          og_image
          og_site_name
          og_url
          twitter_cards_description
          twitter_cards_site
          twitter_cards_site_id
          twitter_cards_title
          twitter_cards_type
          twitter_cards_creator
          twitter_cards_image
          twitter_cards_page_url
          schema_article_author
          schema_article_date_published
          schema_article_description
          schema_article_headline
          schema_article_name
          schema_article_review
          schema_article_type
          schema_person_contact_point
          schema_person_description
          schema_person_email
          schema_person_job_title
          schema_person_name
          schema_person_same_as
          schema_person_telephone
          schema_person_type
          schema_person_url
          schema_web_site_name
          schema_web_site_publisher
          schema_web_site_type
          schema_web_site_url
        }
        title
        path {
          alias
          langcode
        }
      }
    }
  }
  site {
    siteMetadata {
      author
      description
      image
      siteUrl
      title
      twitterUsername
    }
  }
}
`
